<template>
  <section class="PasswordReset0020">
    <el-row :gutter="0" class="PasswordResetHead">
      <router-link to="/sp/0001" class="Router__To__Destination" tabindex="1">
        <i class="el-icon-close" tabindex="1"></i>
      </router-link>
      <el-col :span="6" class="whiteBg">
        <span class="PasswordResetSpan">パスワードリセット</span>
      </el-col>
      <el-col :span="12">
        <img src="../../assets/image/logo-new.png" alt="logo" class="ElnetLogo" />
      </el-col>
      <el-col :span="6"></el-col>
    </el-row>
    <el-row class="PasswordResetBody" v-if="this.show==true">
        <span>メール配信が10分を経過しています。 再度リセット処理を行ってください。</span>
      </el-row>
    <el-row class="PasswordResetBody" v-else>
      <el-form ref="form" :model="getform0020" :rules="rules" label-width="auto">
        <el-form-item label="企業コード" >
        <span>{{ this.getContractCode0020 }}</span>
        </el-form-item>
        <el-form-item label="ユーザーID" prop="user_id">
        <span>{{ this.getUserId0020 }}</span>
        </el-form-item>
        <el-form-item label="パスワード" class="password__confirm" prop="resetpassword">
          <el-input v-model="getform0020.resetpassword" type="password"></el-input>
        </el-form-item>
        <el-form-item label="パスワード(再入力)" class="password__confirm" prop="resetconfirmpassword">
          <el-input v-model="getform0020.resetconfirmpassword" type="password"></el-input>
        </el-form-item>
        <div class="inquiry__btn">
        <el-button type="primary" plain  @click="open1('form')">登録</el-button>
        <el-button type="info" @click="back()" plain >閉じる</el-button>
      </div>
      </el-form>
    </el-row>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import json from "../../components/config.json";
import router from '../../router';
import Vue from 'vue'
//import Common from '../../common/CommonFunc.js'
export default {
  name: "PasswordReset0020",
  props: [],
 
  data() {
    var confirmPass = (rule, value, callback) => {
      var passCheck = this.getform0020.resetpassword;
      if (value != passCheck) {
        callback(new Error("Enter confirm password"));
      } else {
        callback();
      }
    };
    return {
      show:false,
      time:"",
      form: {
        resetpassword: "",
        resetconfirmpassword: ""
      },
      user_id: "",
      contract_code: "",
      rules: {
        resetpassword: [
          { required: true, message: "パスワードを入力してください。" },
          {
            max:256,
            message: "パスワードは256文字以下を入力してください。"
          },
          { pattern:/^[/\u3040-\u30ff\u3400-\u4dbf\uf900-\ufaff\uff66-\uff9fa-zA-Z0-9-@]+$/,message:'パスワードは半角英数字で入力してください。'}
        ],
        resetconfirmpassword: [
          { required: true, message: "パスワード(再入力)を入力してください。" },
          {
            validator: confirmPass,
            message: " パスワードが一致しないので、再入力してください。",
            trigger: "blur"
          }
        ]
      }
    };
  },
 
  computed: {
    // getContractCode:{
    //   get() {
    //     console.log(this.getContractCode0020);
    //     // return this.contract_code;
    //     return this.getContractCode0020;
    //   }
    // },
    // getUserId:{
    //   get() {
    //     console.log(this.getUserId0020);
    //     // return this.user_id;
    //     return this.getUserId0020;
    //   }
    // },
    
    
    
    ...mapGetters("sp_Situation0020", [
      "getform0020",
      "getContractCode0020",
      "getUserId0020",
      "getcheck",
      "getname",
      "getStatus",
      "getMsgCode"
    ]),
    },
 methods: {
  back(){
this.$LogButtonEvent("0020","Close");
this.$LogMethodIN("0020","back");     
    this.$router.push('/sp/0001');
    this.$LogMethodOut("0020","back");
  },
   // reset password from login user
    open1(formName) {
this.$LogButtonEvent("0020","Resgistration");
this.$LogMethodIN("0020","open1");       
      this.$refs[formName].validate(valid => {
        if (valid) {
          var formPassword = {
                            password1: this.getform0020.resetpassword,
                            password2: this.getform0020.resetconfirmpassword,
                            password_resetkey:this.$route.query["k"]
            };
          console.log(formPassword);
          this.$store.dispatch('sp_Communication0020/changePasswordDetails',formPassword).then(() => {
             
            var status = this.getStatus;

              if(status == 0){
                    this.$alert(json["0020_register_success_message"], json["0020_register_success_title"], {
                      confirmButtonText: 'OK',
                    }).then(() => {
                      router.push({name:"sp_0006"});
                    })
                    
                  }
                  else if(this.getMsgCode == "MSG0027"){
                    this.$alert("パスワードリセットの有効期限が過ぎています。再度パスワードリセットの手続きを行ってください", "登録", {
                      confirmButtonText: 'OK',
                    });

                  }
                  else{
                    this.$alert(json["0020_register_failure_message"], json["0020_register_failure_title"], {
                      confirmButtonText: 'OK',
                    });
                  }
              
           })
        } else {
          return false;
        }
      });
      this.$LogMethodOut("0020","open1");
    }
  },
  
  mounted() {
    // var user_id = this.$route.query["user_id"];
    // console.log(user_id);
    // this.user_id = user_id;
    // var contract_code = this.$route.query[" contract_code"];
    // console.log(contract_code); 
    // this.contract_code = contract_code;
    var ResetKey = this.$route.query["k"];
    console.log(ResetKey);
    var cdate = new Date();
    console.log(cdate);
    this.time=Vue.prototype.$session.get('time');
    var new1= new Date(this.time)
   // new1.setMinutes( new1.getMinutes() + 10 );
    console.log(new1)
    if(cdate.getTime() > new1.getTime()){
      this.show=true;
    }else{
       console.log('show')
    }
    //Get table articles during page load
    this.$store.dispatch('sp_Communication0020/getUserDetails',ResetKey);
    

  },
  beforeCreate(){
    
      //Common.Session.SP1_CheckSessionExists_IfExpired_GoToLogout();
      //Common.Session.CheckIsMobile("/sp/0020","/0020"); // MobileScreen Path, WebScreen Path
 }

};



</script>
<style scoped>
    @import "0020.css";
 @import "../../assets/css/customStyle.css"; 
</style>